'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn, useTranslation } from '@whitbread-eos/utils/server';
import { Check } from 'lucide-react';
import React from 'react';
export var BusinessStepType;
(function(BusinessStepType) {
    BusinessStepType["GUEST_DETAILS_PAGE"] = "GUEST_DETAILS_PAGE";
    BusinessStepType["PAYMENT_PAGE"] = "PAYMENT_PAGE";
    BusinessStepType["BOOKING_CONFIRMATION_PAGE"] = "BOOKING_CONFIRMATION_PAGE";
})(BusinessStepType || (BusinessStepType = {}));
export var BusinessStepStatus;
(function(BusinessStepStatus) {
    BusinessStepStatus[BusinessStepStatus["Pending"] = 0] = "Pending";
    BusinessStepStatus[BusinessStepStatus["Active"] = 1] = "Active";
    BusinessStepStatus[BusinessStepStatus["Completed"] = 2] = "Completed";
})(BusinessStepStatus || (BusinessStepStatus = {}));
export function BusinessSteps({ className, lineClassName, type, steps }) {
    const { t } = useTranslation([
        'layout'
    ]);
    const BusinessStepMapping = {
        ["GUEST_DETAILS_PAGE"]: [
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.guestDetails.label'),
                status: 1
            },
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.payment.label'),
                status: 0
            }
        ],
        ["PAYMENT_PAGE"]: [
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.guestDetails.label'),
                status: 2
            },
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.payment.label'),
                status: 1
            }
        ],
        ["BOOKING_CONFIRMATION_PAGE"]: [
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.guestDetails.label'),
                status: 2
            },
            {
                label: t('layout.innbusinessLayout.bookingFlow.step.payment.label'),
                status: 2
            }
        ]
    };
    const baseDataTestId = 'BusinessSteps';
    const resolvedSteps = type ? BusinessStepMapping[type] : steps;
    const currentStep = resolvedSteps.find((step)=>step.status === 1);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": baseDataTestId,
        className: cn(containerStyle, className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: stepContainerStyle,
                children: resolvedSteps.map((step, index)=>/*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            step.status === 0 && /*#__PURE__*/ _jsxs("div", {
                                className: cn(baseStepStyle, pendingStepStyle),
                                children: [
                                    index + 1,
                                    /*#__PURE__*/ _jsx("div", {
                                        className: labelStyle,
                                        children: step.label
                                    })
                                ]
                            }),
                            step.status === 1 && /*#__PURE__*/ _jsxs("div", {
                                className: cn(baseStepStyle, activeStepStyle),
                                children: [
                                    index + 1,
                                    /*#__PURE__*/ _jsx("div", {
                                        className: labelStyle,
                                        children: step.label
                                    })
                                ]
                            }),
                            step.status === 2 && /*#__PURE__*/ _jsxs("div", {
                                className: cn(baseStepStyle, completedStepStyle),
                                children: [
                                    /*#__PURE__*/ _jsx(Check, {
                                        width: 20,
                                        height: 20,
                                        className: "inline"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: labelStyle,
                                        children: step.label
                                    })
                                ]
                            }),
                            index < resolvedSteps.length - 1 && /*#__PURE__*/ _jsx("div", {
                                className: cn(baseLineStyle, lineClassName, resolvedSteps[index].status === 2 ? completedLineStyle : '')
                            })
                        ]
                    }, index))
            }),
            currentStep && /*#__PURE__*/ _jsx("div", {
                className: currentStepLabelStyle,
                children: currentStep.label
            })
        ]
    });
}
const containerStyle = 'w-[250px] mobile:w-full mobile:mt-6';
const stepContainerStyle = 'flex w-full h-12 mobile:h-auto justify-center';
const baseStepStyle = 'relative w-6 h-6 rounded-full flex justify-center align-center';
const pendingStepStyle = 'bg-lightGrey4 text-darkGrey2';
const activeStepStyle = 'bg-darkGrey1 text-baseWhite font-bold';
const completedStepStyle = 'bg-primaryColor text-baseWhite pt-0.5';
const baseLineStyle = 'w-[47px] mobile:w-[136px] h-px mx-[26px] mobile:mx-2 my-3 bg-lightGrey1';
const completedLineStyle = 'bg-primaryColor h-0.5';
const labelStyle = 'mobile:hidden absolute text-black top-7 whitespace-nowrap';
const currentStepLabelStyle = 'hidden mobile:flex justify-center font-bold mt-2';
